<template>
  <div class="row">
    <card-default>
      <div
        slot="title"
        class="card-title h5">
        Brands
      </div>
      <div
        slot="body"
        class="card-text">
        <div class="row">
          <field-input
            v-model="searchString"
            name="searchString"
            label="Search"
            class="col-sm-2"
          />
          <div class="col float-right">
            <auth-link
              to="/brands/new"
              class="btn btn-primary btn-micro float-right"
              permission="brand-create"
            >
              New brand
            </auth-link>
          </div>
        </div>
        <table class="table table-striped first-td-padding">
          <thead>
            <tr>
              <th>
                Brand
              </th>
              <th>
                Updated at
              </th>
              <th/>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="brand in brands"
              :key="brand.slug"
            >
              <td>
                {{ brand.name }}
              </td>
              <td>
                {{ brand.updated_at }}
              </td>
              <td class="text-right">
                <div @click="openBrand(brand)">
                  <div class="btn-group">
                    <auth-button
                      class="btn btn-primary btn-micro"
                      permission="brand-view"
                    >
                      <span
                        aria-hidden="true"
                        class="fa fa-edit"/>
                    </auth-button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card-default>
  </div>
</template>

<script>
import CardDefault from '@/components/CardDefault'
import FieldInput from '@/components/form/FieldInput'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'BrandList',

  components: {
    FieldInput,
    CardDefault
  },

  data () {
    return {
      searchString: ''
    }
  },

  computed: {
    ...mapGetters('brand', [
      'brands'
    ])
  },

  created () {
    this.get()
  },

  methods: {
    ...mapActions('brand', [
      'get'
    ]),
    ...mapMutations('brand', {
      activate: 'SET_ACTIVE'
    }),
    openBrand (brand) {
      this.activate(brand.uuid)
      this.$router.push('/brands/' + brand.uuid)
    }
  }
}
</script>
